import store from "@/store";

export default function hasGameAccess(user) {
    if (!user) return false;

    const isVodacomFreePlay = store.state.brandConfig.brand.includes('vc') && user.freePlayService;
    if (user.status?.toLowerCase() === 'active' && !isVodacomFreePlay) return true;

    return !!user.subscriptionCategories?.some(cat => cat.category === 'SportsHub' && cat.status === 1);
}
